// extracted by mini-css-extract-plugin
module.exports = {"icon":"FavouriteIcon-module__icon___ZWNIk","active":"FavouriteIcon-module__active___2uSh4"};